let activeToast: { msg: string; timer: number; node: HTMLDivElement } | null = null

export function showToast(message: string): void {
  if (activeToast) {
    clearTimeout(activeToast.timer)
    if (activeToast.node.parentNode) activeToast.node.remove()
    activeToast = null
  }

  const toast = document.createElement('div')
  toast.className = 'toast'
  toast.setAttribute('role', 'status')
  toast.setAttribute('aria-live', 'polite')
  toast.textContent = message
  document.body.append(toast)

  void toast.offsetHeight
  toast.classList.add('toast-visible')

  activeToast = {
    msg: message,
    node: toast,
    timer: window.setTimeout(() => {
      if (toast.parentNode) {
        toast.classList.remove('toast-visible')
        toast.classList.add('toast-fade')
        const removeTimer = window.setTimeout(() => {
          if (toast.parentNode) toast.remove()
          if (activeToast?.node === toast) activeToast = null
        }, 400)
        // Store the remove timer so it can be cancelled if a new toast arrives
        if (activeToast) activeToast.timer = removeTimer
      } else {
        if (activeToast?.node === toast) activeToast = null
      }
    }, 3000),
  }
}